require('./targetsWidget.style.scss');

class TargetsWidgetController {
    constructor($scope, $log, $rootScope, utilsService, dashboardService, sharedPersistenceService, styleService) {
        this.$scope = $scope;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this._utilsService = utilsService;
        this._dashboardService = dashboardService;
        this.statusClass = [
            { status: 'success', class: 'progress-bar-success' },
            { status: 'info', class: 'progress-bar-info' },
            { status: 'warning', class: 'progress-bar-warning' },
            { status: 'danger', class: 'progress-bar-danger' },
        ];
        this.totalCount = 0;
        this.targetCapacity = [];
        this.chartColor = styleService.getPercentageCircleBarColor();
        this.chartMax = 0;
        this.chartData = 0;
    }

    $onInit() {
        this.updateData();

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.updateData();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    updateData() {
        if (!this.widgetData) return;
        this.data = this.widgetData;
        this.totalCount = this.data.totalCount;
        let capacity = 0;
        let used = 0;
        this.noTargets = this.data.targets.length === 0;
        this.data.targets.forEach(item => {
            const totalSizeInBytes = item.totalUsageBytes + item.freeSizeInBytes;
            item.usedValue = Math.round(((item.totalUsageBytes * 100) / totalSizeInBytes) * 100) / 100;
            item.availableValue = Math.round(((item.freeSizeInBytes * 100) / totalSizeInBytes) * 100) / 100;
            used += item.totalUsageBytes;
            capacity += totalSizeInBytes;
        }
        );
        if (!angular.isNumber(used)) used = 0;
        this.chartMax = capacity / Math.pow(1024, 3);
        this.chartData = used / Math.pow(1024, 3);

        this.setTargetCapacity();
    }

    setTargetCapacity() {
        this.targetCapacity = this.data.targets.map(entity => (
            {
                name: entity.name, entities: [
                    {
                        status: entity.usedValue >= 90 ? 'danger' : 'success',
                        value: entity.usedValue + '%',
                        title: this._utilsService.expressBytes(entity.totalUsageBytes) + ' (' + entity.usedValue + '%)'
                    },
                    {
                        status: entity.availableValue <= 10 ? 'warning' : 'info',
                        value: entity.availableValue + '%',
                        title: this._utilsService.expressBytes(entity.freeSizeInBytes) + ' (' + entity.availableValue + '%)'
                    }
                ]
            }
        ));
        this.setTargetStyle();
    }

    setTargetStyle() {
        let progressClass = [
            { status: 'success', class: 'progress-bar-success' },
            { status: 'info', class: 'progress-bar-info' },
            { status: 'warning', class: 'progress-bar-warning' },
            { status: 'danger', class: 'progress-bar-danger' },
        ];
        this.targetCapacity.forEach(target => target.entities.forEach((item, i) => {
            item.class = progressClass.filter(sc => sc.status === item.status)[0].class;
            if (i === 1) {
                item.style = { width: item.value || 0, right: 0 };
            } else {
                item.style = { width: item.value || 0 };
            }


        }));
    }
}

TargetsWidgetController.$inject = ['$scope', '$log', '$rootScope', 'utilsService', 'dashboardService', 'sharedPersistenceService', 'styleService'];

const targetsWidgetController = {
    controller: TargetsWidgetController,
    template: require('./targetsWidget.template.html'),
    bindings: { widgetData: '<' },
};

module.exports = targetsWidgetController;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/targetsWidget/targetsWidget.component.js